/**
 * Product Page — Oto-Kupon Bilgi Badge'i
 *
 * Sadece ürün detay sayfasında (/products/...) çalışır.
 * Mevcut kupon scope'una uyan ürünlerde, fiyat altında pembe
 * "Bugüne Özel %X İndirim — 1 saat 12 dk sonra sona erecek" şerit gösterir.
 *
 * DİKKAT — DOKUNMADIĞI YERLER:
 *   - Sepet hesabı (Shopify backend zaten doğru hesaplıyor)
 *   - auto-code-applier.js (kupon uygulama mekanizması)
 *   - Banner sistemi
 *   - Ürün kartı fiyat gösterimi
 *   - "%10 indirim" otomatik altın badge (Shopify discount allocation)
 *
 * SADECE: Bilgilendirici görsel ekleme.
 */
(function () {
  'use strict';

  if (window.__pcbInit) return;
  window.__pcbInit = true;

  // Sadece ürün detay sayfasında çalış
  if (!/^\/products\//.test(location.pathname)) return;

  var API = 'https://dolcevita-massimo.ngrok.io/api/auto-codes/public/active';
  var CAMPAIGN_API = 'https://dolcevita-massimo.ngrok.io/api/campaigns/public/active';
  var BADGE_ID = 'pcb-info-card';
  var REFRESH_INTERVAL_MS = 10000; // sayaç metni 10 saniyede bir yenilenir
  // Son 2 dakika içindeyse 5 saniyede bir kontrol (hassas bitiş için)
  var REFRESH_INTERVAL_FAST_MS = 5000;
  var FAST_THRESHOLD_MS = 120000;  // son 2 dakika

  // ═══════════════════════════════════════════════════════════════
  // HELPERS
  // ═══════════════════════════════════════════════════════════════

  function log() { /* production: log kapalı */ }

  function getProductHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  /**
   * Sayfadaki mevcut ürün fiyatını DOM'dan oku.
   * Bu fiyat Shopify'ın automatic discount'unu zaten içerir.
   * Format: "5.531,04 TL" → 5531.04 (number)
   * Bulamazsa null döner.
   */
  function readCurrentPrice() {
    // Yay teması (hdt-) gerçek class'ları:
    // .hdt-price, .hdt-price__list, .hdt-money, .hdt-price-item--last
    // İndirimli fiyat genelde .hdt-price-item--last veya .hdt-money sınıfında
    // Compare-at-price (üstü çizili) ayrı class: .hdt-compare-at-price (BUNU ALMA)
    var selectors = [
      // Yay/hdt teması — main-product içindeki fiyat
      '.hdt-main-product .hdt-price-item--last',
      '.hdt-main-product .hdt-price__list .hdt-money:not(.hdt-compare-at-price)',
      '.hdt-main-product .hdt-money:not(.hdt-compare-at-price)',
      '.hdt-product-info .hdt-price-item--last',
      '.hdt-product-info .hdt-money:not(.hdt-compare-at-price)',
      // Daha geniş kapsam (eğer yukarıdakiler bulamazsa)
      '.hdt-price-item--last',
      '.hdt-price__list .hdt-money:not(.hdt-compare-at-price)',
      '.hdt-price .hdt-money:not(.hdt-compare-at-price)',
      // Genel fallback
      '[data-product-price]',
      '.product__price--sale',
      '.price__sale'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        // .hdt-compare-at-price içindeyse atla (üstü çizili eski fiyat)
        // Yukarıdaki :not() bazı tarayıcılarda sıkı çalışmıyor — dolayısıyla manuel kontrol
        if (el.closest && el.closest('.hdt-compare-at-price, s, del, .price--compare')) continue;

        // Visible value oku (sayfanın gerçekten gösterdiği fiyat)
        var raw = (el.textContent || '').trim();
        if (!raw) continue;

        // Türkçe parse — "6.145,60 TL" → 6145.60
        // Ama sıralama önemli: önce binlik nokta, sonra virgül ondalık
        // Edge case: "5,22 TL" (binlik yok), "6.145,60", "1.234.567,89"
        var parsed = parseTurkishPrice(raw);
        log('readCurrentPrice try selector:', selectors[i], '|', el.tagName + '.' + (el.className || ''),
            '| raw:', JSON.stringify(raw), '| parsed:', parsed);
        if (parsed && parsed > 0) {
          return parsed;
        }
      }
    }
    log('readCurrentPrice: HİÇBİR SELECTOR TUTMADI veya parse fail');
    return null;
  }

  /**
   * Türkçe fiyat formatı parser — "6.145,60 TL" → 6145.60
   * Edge cases:
   *   "6.145,60 TL"  → 6145.60   (binlik nokta + virgül ondalık)
   *   "5,22 TL"      → 5.22      (sadece virgül ondalık)
   *   "1.234,567"    → 1234.567  (binlik + virgül + 3 hane ondalık — nadir)
   *   "100 TL"       → 100       (ondalık yok)
   *   "  6.145,60  " → 6145.60   (whitespace)
   */
  /**
   * Akıllı fiyat parser — hem Türkçe (1.234,56) hem Amerikan (1,234.56) formatı.
   * SON ayırıcının pozisyonu ondalık ayırıcısını belirler.
   *
   * Algoritma:
   *   1. Cleaned text içinde son virgül ve son noktanın pozisyonunu bul
   *   2. SON gelen ayırıcı = ondalık ayırıcı
   *   3. Diğer ayırıcı = binlik (silinir)
   *   4. Tek tip ayırıcı varsa: 3 haneli grup → binlik, değilse → ondalık
   *
   * Edge cases:
   *   "6.145,60 TL"  → 6145.60   (TR — son virgül)
   *   "5,531.04 TL"  → 5531.04   (US — son nokta)
   *   "5,22 TL"      → 5.22      (TR — sadece virgül)
   *   "5.22"         → 5.22      (US — 1 nokta + 2 hane)
   *   "5.221"        → 5221      (TR binlik — 1 nokta + 3 hane)
   *   "1,234,567.89" → 1234567.89 (US — son nokta)
   *   "1.234.567,89" → 1234567.89 (TR — son virgül)
   */
  function parseTurkishPrice(s) {
    if (!s) return null;
    var cleaned = s.replace(/[^\d,.]/g, '');
    if (!cleaned) return null;

    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');

    // İki ayırıcı da var → SON gelen ondalık ayırıcı
    if (lastComma >= 0 && lastDot >= 0) {
      if (lastComma > lastDot) {
        // SON virgül → TR format ("6.145,60")
        var ip = cleaned.substring(0, lastComma).replace(/[.,]/g, '');
        var dp = cleaned.substring(lastComma + 1).replace(/[.,]/g, '');
        var n1 = parseFloat(ip + '.' + dp);
        return isNaN(n1) ? null : n1;
      } else {
        // SON nokta → US format ("5,531.04")
        var ip2 = cleaned.substring(0, lastDot).replace(/[.,]/g, '');
        var dp2 = cleaned.substring(lastDot + 1).replace(/[.,]/g, '');
        var n2 = parseFloat(ip2 + '.' + dp2);
        return isNaN(n2) ? null : n2;
      }
    }

    // Sadece virgül var (TR ondalık veya tek virgüllü binlik — TR'de binlik virgül yok, ondalık kabul et)
    if (lastComma >= 0) {
      var commaCount = (cleaned.match(/,/g) || []).length;
      if (commaCount === 1) {
        var after = cleaned.substring(lastComma + 1);
        // 1-2 hane sonra → ondalık (TR), 3 hane → büyük ihtimalle TR ondalık ("1,234" gibi US binlik nadir TR'de)
        // TR'de virgül her zaman ondalıktır kuralı
        return parseFloat(cleaned.replace(',', '.'));
      }
      // Birden fazla virgül → US binlik ("1,234,567" → 1234567)
      return parseFloat(cleaned.replace(/,/g, ''));
    }

    // Sadece nokta var
    if (lastDot >= 0) {
      var dotCount = (cleaned.match(/\./g) || []).length;
      if (dotCount === 1) {
        var afterDot = cleaned.substring(lastDot + 1);
        // 3 hane → TR binlik ("6.145"), 1-2 → US ondalık ("5.22")
        if (afterDot.length === 3) return parseFloat(cleaned.replace('.', ''));
        return parseFloat(cleaned);
      }
      // Birden fazla nokta → TR binlik ("1.234.567")
      return parseFloat(cleaned.replace(/\./g, ''));
    }

    return parseFloat(cleaned);
  }

  /**
   * Sayı → "5.531,04 TL" formatında Türkçe görünüm.
   */
  function fmtTRY(n) {
    if (typeof n !== 'number' || isNaN(n)) return '';
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function getCollectionHandle() {
    // URL: /collections/{handle}/products/{handle}
    var m = location.pathname.match(/\/collections\/([^/]+)\//);
    if (m) return decodeURIComponent(m[1]).toLowerCase();
    // Veya body class'ında: template-product collection-handle-xxx
    var bc = (document.body && document.body.className) || '';
    var cm = bc.match(/collection-handle-([a-z0-9-]+)/);
    return cm ? cm[1] : null;
  }

  // Variant ID'yi 3 kaynaktan dener: URL ?variant=, form input[name=id], select[name=id]
  function getCurrentVariantId() {
    try {
      var u = new URL(location.href);
      var v = u.searchParams.get('variant');
      if (v) return v;
    } catch (e) {}
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]')
           || document.querySelector('[name="id"][value]');
    if (inp && inp.value) return inp.value;
    return null;
  }

  /**
   * Statik kalan süre metni — kullanıcı dostu uzun format.
   * "2 gün 4 saat 12 dakika sonra sona erecek"
   * "1 saat 12 dakika sonra sona erecek"
   * "12 dakika sonra sona erecek"
   * "Son saniyeler"
   */
  function fmtRemaining(endsAtIso) {
    if (!endsAtIso) return null;
    var end = new Date(endsAtIso);
    if (isNaN(end.getTime())) return null;
    var diffMs = end.getTime() - Date.now();
    if (diffMs <= 0) return null; // bittiyse hiç render etme
    var totalSec = Math.floor(diffMs / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var mins = Math.floor((totalSec % 3600) / 60);

    var parts = [];
    if (days > 0) parts.push(days + ' gün');
    if (hours > 0) parts.push(hours + ' saat');
    if (mins > 0 && days === 0) parts.push(mins + ' dakika'); // gün varsa dakikayı atla
    if (parts.length === 0) return 'Son saniyeler — kaçırma!';

    return parts.join(' ') + ' sonra sona erecek';
  }

  /**
   * Kuponun bu ürüne uyup uymadığını kontrol et.
   * Scope tipi: 'product' | 'collection' | 'all'
   */
  function couponMatchesProduct(coupon, productHandle, collectionHandle, variantId) {
    if (!coupon || !coupon.scope) return false;
    var s = coupon.scope;

    if (s.type === 'product') {
      // YENİ: productPicks varsa variant-aware kontrol
      // (backend /public/active endpoint productPicks'i artık döndürüyor)
      if (Array.isArray(s.productPicks) && s.productPicks.length) {
        var pick = null;
        for (var i = 0; i < s.productPicks.length; i++) {
          if (s.productPicks[i] && s.productPicks[i].handle === productHandle) {
            pick = s.productPicks[i]; break;
          }
        }
        if (!pick) return false;
        var vGids = (pick.variantGids || []);
        // variantGids boş = tüm ebatlar match
        if (!vGids.length) return true;
        // Belirli ebatlar: variantId eşleşmeli
        if (!variantId) return false;
        var idStr = String(variantId).replace('gid://shopify/ProductVariant/', '');
        var fullGid = 'gid://shopify/ProductVariant/' + idStr;
        return vGids.indexOf(fullGid) !== -1;
      }
      // Eski: sadece productHandles varsa
      var handles = Array.isArray(s.productHandles) ? s.productHandles : [];
      return handles.indexOf(productHandle) !== -1;
    }

    if (s.type === 'collection') {
      // Backend expansion: productHandles dolu olabilir (collection scope için)
      // Direkt ürün sayfasında URL'de collection yok ama productHandles eşleşir.
      if (Array.isArray(s.productHandles) && s.productHandles.length) {
        if (s.productHandles.indexOf(productHandle) !== -1) return true;
      }
      // Eski: collection sayfası URL eşleşmesi (örn /collections/el-hamra-serisi/products/...)
      if (!collectionHandle) return false;
      if (Array.isArray(s.collectionHandles)) {
        return s.collectionHandles.indexOf(collectionHandle) !== -1;
      }
      return false;
    }

    if (s.type === 'all') {
      return true;
    }

    return false;
  }

  /**
   * Kuponun şu an aktif olup olmadığını kontrol et.
   * - status === 'active'
   * - startsAt geçmiş
   * - endsAt geçmemiş (null ise süresiz, OK)
   * - Kampanyaya bağlıysa kampanya da aktif olmalı
   */
  function isCouponActiveNow(coupon, activeCampaignIds) {
    if (!coupon || coupon.status !== 'active') return false;

    var now = Date.now();
    if (coupon.startsAt && new Date(coupon.startsAt).getTime() > now) return false;
    if (coupon.endsAt && new Date(coupon.endsAt).getTime() <= now) return false;

    // Kampanyaya bağlıysa, kampanya aktif kümesinde olmalı
    if (coupon.campaignId) {
      if (!activeCampaignIds || activeCampaignIds.indexOf(coupon.campaignId) === -1) return false;
    }

    return true;
  }

  // ═══════════════════════════════════════════════════════════════
  // FETCH
  // ═══════════════════════════════════════════════════════════════

  var _coupons = null;
  var _activeCampaignIds = [];

  function fetchAll() {
    var pCoupons = fetch(API, { credentials: 'omit', mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : { codes: [] }; })
      .then(function (j) { _coupons = (j && j.codes) || []; })
      .catch(function () { _coupons = []; });

    var pCampaigns = fetch(CAMPAIGN_API, { credentials: 'omit', mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : { campaigns: [] }; })
      .then(function (j) {
        var camps = (j && j.campaigns) || [];
        _activeCampaignIds = camps
          .filter(function (c) { return c.status === 'active'; })
          .map(function (c) { return c.id; });
      })
      .catch(function () { _activeCampaignIds = []; });

    return Promise.all([pCoupons, pCampaigns]);
  }

  // ═══════════════════════════════════════════════════════════════
  // BADGE INJECTION
  // ═══════════════════════════════════════════════════════════════

  /**
   * Badge'i inject edilecek hedef element'i bul.
   * Tema bazlı — en yaygın seçicileri dener.
   * Hiçbiri tutmazsa null döner ve render edilmez (graceful).
   */
  function findInjectionTarget() {
    // Pembe kartı .hdt-product__price (fiyat ITEM'in TAMAMI) ÜZERINDE NextSibling olarak
    // yerleştirmek için target = .hdt-product__price (fiyat item'in DIŞ kökü)
    // Böylece fiyat container'ının içine sızmaz, alt komşusu olarak yerleşir
    var selectors = [
      '.hdt-product-info__item.hdt-product__price',
      '.hdt-product__price',
      '.hdt-product-info .hdt-price-wrapp',
      '.hdt-main-product .hdt-price-wrapp',
      // Eski hedefler (fallback)
      '.hdt-product-info .hdt-price',
      '.hdt-main-product .hdt-price',
      '.hdt-price',
      '.product__price',
      '.product-single__price',
      '.price',
      '[data-product-price]',
      'product-form',
      'form[action*="/cart/add"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function buildBadgeHTML(coupon) {
    var title = coupon.title || (coupon.code ? '%' + (coupon.discount && coupon.discount.value) + ' İndirim Kuponu' : 'Özel İndirim');
    var remaining = fmtRemaining(coupon.endsAt);

    // Title escape
    var safeTitle = String(title).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    // Fiyat hesabı — DOM'dan mevcut fiyat (Shopify automatic %10 zaten düşülmüş)
    // Kupon %'sini ekstra uygula → sepet son fiyatı
    var currentPrice = readCurrentPrice();
    var priceHtml = '';
    if (currentPrice && coupon.discount && coupon.discount.type === 'percentage' && coupon.discount.value > 0) {
      // Min sepet kontrolü — koşul sağlanmıyorsa hesap gösterme (yanıltıcı olur)
      var minOk = !coupon.minSubtotal || currentPrice >= coupon.minSubtotal;

      if (minOk) {
        var newPrice = currentPrice * (1 - coupon.discount.value / 100);
        newPrice = Math.round(newPrice * 100) / 100;

        priceHtml = ''
          + '<div class="pcb-card__price-block">'
          + '  <div class="pcb-card__price-label">Sepet Fiyatı</div>'
          + '  <div class="pcb-card__price-new">' + fmtTRY(newPrice) + '</div>'
          + '</div>';
      } else if (coupon.minSubtotal) {
        priceHtml = ''
          + '<div class="pcb-card__price-block pcb-card__price-block--minsub">'
          + '  <div class="pcb-card__price-note">Sepet ' + fmtTRY(coupon.minSubtotal) + ' üstü olunca uygulanır</div>'
          + '</div>';
      }
    }

    // Premium tasarım: krem zemin, üst caps şerit, büyük tipografi, emoji yok
    // Üst satır: "ÖZEL TEKLİF • SAYAÇ" (uppercase, letter-spacing)
    // Başlık: kupon adı (orta punto, koyu gri)
    // Alt: opsiyonel fiyat satırı (büyük, premium)
    // coupon.id YOKSA coupon.code kullan (public/active endpoint id field'ı vermiyor olabilir)
    var couponKey = coupon.id || coupon.code || '';
    var html = ''
      + '<div id="' + BADGE_ID + '" class="pcb-card" data-pcb-coupon="' + couponKey + '">';

    // Üst caps şerit
    var topLine = 'ÖZEL TEKLİF';
    if (remaining) {
      topLine += ' <span class="pcb-card__sep">•</span> <span class="pcb-card__time-text" data-pcb-ends-at="' + coupon.endsAt + '">' + remainingCaps(remaining) + '</span>';
    }
    html += '<div class="pcb-card__eyebrow">' + topLine + '</div>';

    // Başlık
    html += '<div class="pcb-card__title">' + safeTitle + '</div>';

    // Fiyat bloğu (varsa)
    html += priceHtml;

    html += '</div>';
    return html;
  }

  /**
   * Sayaç metnini UPPERCASE TEK SATIR formatına çevirir.
   * "3 saat 6 dakika sonra sona erecek" → "3 SAAT 6 DK KALDI"
   */
  function remainingCaps(s) {
    if (!s) return '';
    var t = String(s)
      .replace(/sonra sona erecek/gi, 'kaldı')
      .replace(/dakika/gi, 'dk')
      .replace(/Son saniyeler — kaçırma!/gi, 'SON SANİYELER');
    return t.toUpperCase();
  }

  function removeBadge() {
    var el = document.getElementById(BADGE_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
    var wr = document.getElementById('pcb-extra-badge-wrapper');
    if (wr && wr.parentNode) wr.parentNode.removeChild(wr);
    var note = document.getElementById('pcb-checkout-note');
    if (note && note.parentNode) note.parentNode.removeChild(note);
  }

  function renderBadge(coupon) {
    removeBadge();
    var target = findInjectionTarget();
    if (!target) {
      log('inject target bulunamadı, badge atlandı');
      return;
    }

    // Pembe kartın gideceği FİYAT ITEM'i (root level) bul
    // Mobile'da fiyat→kart→taksit sırası için kart .hdt-product__price'ın HEMEN ARDINDA olmalı
    // .hdt-product__price = .hdt-product-info__item olduğu için onun parent'ı
    // .hdt-product-info içinde sibling sırası takip edilir
    var priceItem = target.closest('.hdt-product-info__item') || target;
    
    var html = buildBadgeHTML(coupon);
    var div = document.createElement('div');
    div.innerHTML = html.trim();
    var node = div.firstChild;

    // ÖNCELİK 1: Taksit kutusunun (.product-info-taksit) HEMEN ÜSTÜNE
    // Bu Dolce Vita Halı'nın özel taksit kutusu, ürün sayfasında belirgin yerde
    var taksitBox = document.querySelector('.product-info-taksit');
    if (taksitBox && taksitBox.parentNode) {
      taksitBox.parentNode.insertBefore(node, taksitBox);
      log('badge eklendi (BEFORE .product-info-taksit):', coupon.code);
    } else if (priceItem.parentNode) {
      // ÖNCELİK 2: Fiyat ITEM'in hemen ardına (taksit kutusu yoksa)
      if (priceItem.nextSibling) {
        priceItem.parentNode.insertBefore(node, priceItem.nextSibling);
      } else {
        priceItem.parentNode.appendChild(node);
      }
      log('badge eklendi (after price item, no taksit box):', coupon.code);
    } else {
      // Son çare
      if (target.nextSibling) target.parentNode.insertBefore(node, target.nextSibling);
      else target.parentNode.appendChild(node);
      log('badge eklendi (fallback):', coupon.code);
    }

    renderExtraBadge(coupon);
    renderCheckoutNote(coupon);
    // Sayaç metnini periyodik yenileme — her renderBadge çağrısında re-start
    // (re-init guard interval içinde var, duplicate olmaz)
    startCounterRefresh();
  }

  /**
   * "Sepete Ekle" butonunun ALTINA küçük not — kuponlu çıkış fiyatı.
   * Sadece kupon aktifse render edilir; kupon biterse otomatik kaldırılır.
   * Buton dokunulmaz (Shopify kendisi yönetiyor) — sadece komşu sibling note.
   */
  function renderCheckoutNote(coupon) {
    if (!coupon.discount || coupon.discount.type !== 'percentage' || !coupon.discount.value) return;
    // Süre dolmuşsa render etme
    if (coupon.endsAt && new Date(coupon.endsAt).getTime() <= Date.now()) return;

    var currentPrice = readCurrentPrice();
    if (!currentPrice) return;

    // Min sepet altıysa not gösterme (kuponlu fiyat zaten uygulanmayacak)
    if (coupon.minSubtotal && currentPrice < coupon.minSubtotal) return;

    var newPrice = Math.round(currentPrice * (1 - coupon.discount.value / 100) * 100) / 100;

    // Eski note varsa temizle
    var prev = document.getElementById('pcb-checkout-note');
    if (prev && prev.parentNode) prev.parentNode.removeChild(prev);

    // Sepete Ekle butonunu bul (form veya cart-add buton)
    // Yay teması: <button name="add" type="submit" class="hdt-btn hdt-product-form__cart-button">
    var btnSelectors = [
      'button[name="add"]',
      '.hdt-product-form__cart-button',
      '.product-form__submit',
      '[data-add-to-cart]',
      'button[type="submit"][form*="product-form"]'
    ];
    var btn = null;
    for (var i = 0; i < btnSelectors.length; i++) {
      btn = document.querySelector(btnSelectors[i]);
      if (btn) break;
    }
    if (!btn) {
      log('renderCheckoutNote: Sepete Ekle butonu bulunamadı, skip');
      return;
    }

    // Note container — butonun hemen ALTINA insert edilecek
    var note = document.createElement('div');
    note.id = 'pcb-checkout-note';
    note.className = 'pcb-checkout-note';
    note.setAttribute('data-pcb-final', String(newPrice));
    note.innerHTML =
      '<span class="pcb-checkout-note__hint">Sepete eklediğinizde bu ürünü </span>' +
      '<span class="pcb-checkout-note__price">' + fmtTRY(newPrice) + '</span>' +
      '<span class="pcb-checkout-note__hint">&apos;ye satın alabilirsiniz</span>';

    // Butonun parent'ında, butonun hemen ardına yerleştir
    var anchor = btn.closest('.hdt-product-form__buttons, .product-form__buttons, .product-form, form') || btn;
    if (anchor.parentNode) {
      if (anchor.nextSibling) {
        anchor.parentNode.insertBefore(note, anchor.nextSibling);
      } else {
        anchor.parentNode.appendChild(note);
      }
      log('checkout note eklendi: ' + fmtTRY(newPrice));
    }
  }

  /**
   * Mevcut .discount-badge'in HEMEN ALTINA "+%X ekstra" altın chip ekler.
   * Aynı .discount-badge class'ını miras alır → boyut/şekil aynı, sadece renk altın.
   * Wrapper div width:100% sayesinde flex parent içinde alt satıra düşer.
   */
  function renderExtraBadge(coupon) {
    if (!coupon.discount || coupon.discount.type !== 'percentage' || !coupon.discount.value) return;
    // Süre dolmuşsa render etme
    if (coupon.endsAt && new Date(coupon.endsAt).getTime() <= Date.now()) return;
    var pct = coupon.discount.value;

    // Eski extra badge'leri TEMIZLE — hem id-based hem class-based
    // (Variant değişimi sırasında orphan badge'ler kalabiliyor)
    var olds = document.querySelectorAll('#pcb-extra-badge-wrapper, .pcb-extra-badge');
    for (var o = 0; o < olds.length; o++) {
      if (olds[o].parentNode) olds[o].parentNode.removeChild(olds[o]);
    }

    // Mevcut tema badge'ini bul (Dolce Vita Halı için: .discount-badge)
    var existingBadge = document.querySelector('.discount-badge');
    if (!existingBadge) {
      log('renderExtraBadge: .discount-badge bulunamadı, skip');
      return;
    }

    // Wrapper — width:100% ile flex parent içinde alt satıra düşer
    var wrapper = document.createElement('div');
    wrapper.id = 'pcb-extra-badge-wrapper';

    // Chip — aynı class hierarchy → tema CSS'i aynı boyut/şekil verir
    var chip = document.createElement('div');
    chip.id = 'pcb-extra-badge';
    // SADECE pcb-extra-badge class — tema "discount-badge" class'lı her şeyi "%10 indirim"
    // text override etmeye çalışıyor olabilir. Class'ı temiz tutuyoruz, stil tamamen
    // bizim CSS'imizden geliyor (yan badge için yeni base style ekleyeceğiz).
    chip.className = 'pcb-extra-badge';
    chip.innerHTML = '<span class="pcb-extra-badge__percent">+%' + pct + '</span><span class="pcb-extra-badge__text"> ekstra</span>';

    wrapper.appendChild(chip);

    // %10 ile %15'i aynı flex container içinde TUT
    // Wrapper width:100% + flex-basis:100% sayesinde alt satıra düşer
    // CSS order: %10 (90), %15 wrapper (99) → %10 önce, %15 sonra
    if (existingBadge.parentNode) {
      if (existingBadge.nextSibling) {
        existingBadge.parentNode.insertBefore(wrapper, existingBadge.nextSibling);
      } else {
        existingBadge.parentNode.appendChild(wrapper);
      }
      log('extra badge eklendi: +%' + pct + ' ekstra');
    }
  }

  /**
   * Sayaç metnini periyodik güncelle.
   * Sayfa açık kaldığı sürece her 60 sn'de bir "1 saat 12 dakika sonra..." metnini yeniler.
   * Süre dolduysa badge'i kaldırır.
   */
  function startCounterRefresh() {
    // Önce eski interval varsa temizle
    if (window.__pcbCounterTimer) clearInterval(window.__pcbCounterTimer);

    function tick() {
      var span = document.querySelector('#' + BADGE_ID + ' [data-pcb-ends-at]');
      if (!span) {
        // Badge yok — sayaç da gerek yok
        if (window.__pcbCounterTimer) clearInterval(window.__pcbCounterTimer);
        window.__pcbCounterTimer = null;
        return;
      }
      var endsAt = span.getAttribute('data-pcb-ends-at');
      var rawRemaining = fmtRemaining(endsAt);

      if (!rawRemaining) {
        // ⏰ SÜRE DOLDU — TÜM otomatik temizlik
        removeBadge();
        if (window.__pcbCounterTimer) clearInterval(window.__pcbCounterTimer);
        window.__pcbCounterTimer = null;

        // Sepetteki kuponu da kaldırmak için auto-code-applier'a sinyal ver
        // (sayfa açıkken kupon biterse müşteri sepetinde stale kalmasın)
        if (typeof window.dispatchEvent === 'function') {
          try {
            window.dispatchEvent(new CustomEvent('pcb:coupon-expired', {
              detail: { endsAt: endsAt }
            }));
          } catch (e) {}
        }
        return;
      }

      // Aksi halde: metni güncelle
      span.textContent = remainingCaps(rawRemaining);

      // Adaptive interval — son 2 dakika kaldıysa daha sık check
      var diffMs = new Date(endsAt).getTime() - Date.now();
      var nextDelay = (diffMs <= FAST_THRESHOLD_MS) ? REFRESH_INTERVAL_FAST_MS : REFRESH_INTERVAL_MS;

      // Mevcut timer'ı kapat, yeni delay ile yeniden kur
      if (window.__pcbCounterTimer) clearInterval(window.__pcbCounterTimer);
      window.__pcbCounterTimer = setTimeout(tick, nextDelay);
    }

    // İlk tick — hemen tetikle (mevcut metin doğru olsun)
    tick();
  }

  // ═══════════════════════════════════════════════════════════════
  // MAIN
  // ═══════════════════════════════════════════════════════════════

  function run() {
    var productHandle = getProductHandle();
    if (!productHandle) return;
    var collectionHandle = getCollectionHandle();
    var variantId = getCurrentVariantId();

    fetchAll().then(function () {
      if (!_coupons || !_coupons.length) return;

      // Bu ürüne uyan + şu an aktif olan kuponu bul (ilk eşleşme)
      var matched = null;
      for (var i = 0; i < _coupons.length; i++) {
        var c = _coupons[i];
        if (!isCouponActiveNow(c, _activeCampaignIds)) continue;
        if (couponMatchesProduct(c, productHandle, collectionHandle, variantId)) {
          matched = c;
          break;
        }
      }

      if (matched) {
        // Çift kontrol: matched kuponun endsAt'i şu anda hala gelecek mi?
        if (matched.endsAt && new Date(matched.endsAt).getTime() <= Date.now()) {
          removeBadge();
          return;
        }
        renderBadge(matched);
        // startCounterRefresh renderBadge sonunda çağrılıyor — burada tekrar gerekmez
      } else {
        removeBadge();
      }
    });
  }

  // Sayfa hazır olduğunda çalıştır
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Tema kendi product info DOM'unu zaman zaman geç inject edebilir, küçük bir delay
      setTimeout(run, 200);
    });
  } else {
    setTimeout(run, 200);
  }

  // Quick view veya AJAX ile ürün değişirse re-run (opsiyonel hook)
  window.__pcbRefresh = run;

  /**
   * Variant değişimi DOM observer.
   * Tema variant'a tıklayınca fiyatı update ediyor → biz de hesabı yeniliyoruz.
   * Sadece fiyat içeren elementleri izle, gereksiz re-render yapmamak için.
   */
  function watchVariantChange() {
    // Önemli: Yay teması variant seçimini "select change" event'i ile yapar,
    // fiyatı ise input/select içeren PARENT'tan farklı bir DOM node'unda günceller.
    // Bu yüzden hem MutationObserver, hem de polling yaklaşımı kullanıyoruz.

    var lastKnownPrice = null;
    var refreshTimer = null;

    function checkPriceAndRefresh() {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        var currentPrice = readCurrentPrice();
        if (currentPrice && currentPrice !== lastKnownPrice) {
          var oldPrice = lastKnownPrice;
          lastKnownPrice = currentPrice;
          log('🔄 FİYAT DEĞİŞTİ:', oldPrice, '→', currentPrice, '— run() yeniden değerlendiriyor');
          // Aşama 4-3 sadeleştirme: run() tek doğru karar yeri.
          // Sayfa açılışıyla AYNI mantık (variantId al → match bul → render VEYA remove).
          // Eski karmaşık coupon-arama mantığı badge yokken erken çıkıp kartın geri
          // gelmesini engelliyordu. run() bu sorunu otomatik çözer.
          run();
        }
      }, 250);
    }

    // 1) MutationObserver — DOM değişimi izle (en hızlı tepki)
    if (typeof MutationObserver !== 'undefined') {
      var watchTarget = document.querySelector('.hdt-main-product, .hdt-product-info, [data-product-info]');
      if (watchTarget) {
        var observer = new MutationObserver(checkPriceAndRefresh);
        observer.observe(watchTarget, { childList: true, characterData: true, subtree: true, attributes: false });
        log('MutationObserver aktif — target:', watchTarget.className.substring(0, 60));
      }
    }

    // 2) Variant select/input change — daha kesin sinyal
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      var name = (e.target.name || '').toLowerCase();
      var type = (e.target.type || '').toLowerCase();
      if (name.includes('boyut') || name.includes('option') || name === 'id' ||
          type === 'radio' || type === 'select-one') {
        log('variant change event:', e.target.tagName, name || type);
        // Fiyat update'inin tamamlanmasını bekle (Yay teması ~150-300ms gecikme)
        setTimeout(checkPriceAndRefresh, 200);
        setTimeout(checkPriceAndRefresh, 500);  // ikinci dene (geç değişen tema'lar için)
      }
    }, true);

    // 3) Polling fallback — son 5 saniyede her saniye fiyat kontrolü
    // (MutationObserver tutmazsa veya event yakalanmazsa bile yakalar)
    var pollCount = 0;
    var pollTimer = setInterval(function () {
      pollCount++;
      checkPriceAndRefresh();
      if (pollCount > 20) clearInterval(pollTimer); // 20 saniye sonra kapat
    }, 1000);

    // İlk fiyatı kaydet (baseline)
    setTimeout(function () {
      lastKnownPrice = readCurrentPrice();
      log('Variant observer baseline price:', lastKnownPrice);
    }, 500);
  }

  // ESKI MutationObserver bloğu — yukarıda tamamen yeniden yazıldı, aşağıdaki dead code:
  function _OLD_watchVariantChange_unused() {
    if (typeof MutationObserver === 'undefined') return;
    var watchTarget = document.querySelector('.hdt-main-product .hdt-price__list, .hdt-main-product .hdt-price, .hdt-product-info .hdt-price, [data-product-info]');
    if (!watchTarget) return;
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        // Aktif kupon varsa sadece badge'in fiyat satırını yenile
        var badge = document.getElementById(BADGE_ID);
        if (!badge) return;
        var couponId = badge.getAttribute('data-pcb-coupon');
        var coupon = (_coupons || []).find(function (c) { return c.id === couponId; });
        if (!coupon) return;

        // Yeni fiyat hesabı
        var currentPrice = readCurrentPrice();
        if (!currentPrice) return;
        var minOk = !coupon.minSubtotal || currentPrice >= coupon.minSubtotal;
        var priceRow = badge.querySelector('.pcb-card__price-block');

        if (coupon.discount && coupon.discount.type === 'percentage' && coupon.discount.value > 0 && minOk) {
          var newPrice = Math.round(currentPrice * (1 - coupon.discount.value / 100) * 100) / 100;
          var html = ''
            + '<div class="pcb-card__price-label">Sepet Fiyatı</div>'
            + '<div class="pcb-card__price-new">' + fmtTRY(newPrice) + '</div>';
          // priceRow artık .pcb-card__price-block (yeni class)
          var priceBlock = badge.querySelector('.pcb-card__price-block');
          if (priceBlock) {
            priceBlock.className = 'pcb-card__price-block';
            priceBlock.innerHTML = html;
          } else {
            var div = document.createElement('div');
            div.className = 'pcb-card__price-block';
            div.innerHTML = html;
            badge.appendChild(div);
          }

          // Checkout note'u da güncelle
          var note = document.getElementById('pcb-checkout-note');
          if (note) {
            var priceEl = note.querySelector('.pcb-checkout-note__price');
            if (priceEl) priceEl.textContent = fmtTRY(newPrice);
            note.setAttribute('data-pcb-final', String(newPrice));
          } else {
            renderCheckoutNote(coupon);
          }

          // ═══ %15 EKSTRA chip — variant değiştiğinde tema container'ı yeniden
          // render ediyor, eski chip kayboluyor. Yeniden inject et.
          // Önce eski wrapper'ı manuel temizle (eğer varsa duplicate'lerden korunmak için)
          var oldWrappers = document.querySelectorAll('#pcb-extra-badge-wrapper, .pcb-extra-badge');
          for (var ow = 0; ow < oldWrappers.length; ow++) {
            if (oldWrappers[ow].parentNode) oldWrappers[ow].parentNode.removeChild(oldWrappers[ow]);
          }
          // Sonra yeniden render
          renderExtraBadge(coupon);
        }
      }, 300); // debounce — variant tıklayınca tema 100-200ms sonra fiyatı update eder
    });
    observer.observe(watchTarget, { childList: true, characterData: true, subtree: true });
    log('variant change observer aktif');
  }

  // Sayfa yüklendikten 1 sn sonra observer'ı başlat (tema kendi DOM'unu hazırlasın)
  setTimeout(watchVariantChange, 1000);

})();
